import { render } from "./PeopleStanford.vue?vue&type=template&id=563cd292"
import script from "./PeopleStanford.vue?vue&type=script&lang=js"
export * from "./PeopleStanford.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__